<template>
    <section>
        <v-select
            v-model="internalValue"
            :options="countries"
            :placeholder="$t('register.countries')"
            @option:selected="handle"
            @option:deselected="handle"
            :multiple="false"
            :clearable="false"
            :disable="countries.length === 0"
        ></v-select>
    </section>
</template>
<script>
import {defineComponent} from 'vue';
import { useAppStore } from '@stores/App';

export default defineComponent({
    props: {
        value: null,
    },
    watch: {
        value: {
            handler(val) {
                this.internalValue = val;
            },
        }
    },
    async mounted() {
        const app = useAppStore();
        const geo = await app.getGeoCountry();
        this.countries = app.getCountries();
        const preselect = this.countries.find((country) => country.id === geo);

        if (preselect) {
            this.internalValue = preselect;
        }
        this.$emit('input', this.internalValue);
    },
    data() {
        return {
            internalValue: { id: 'SE', label: 'Sweden' },
            countries: [],
        }
    },
    methods: {
        handle(event) {
            this.$emit('input', event);
        },
        sortLabelByAZ(a, b){
            if (a.label > b.label) {
                return 1;
            }
            if (b.label > a.label) {
                return -1;
            }
            return 0;
        },
    },
});
</script>
